import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const Palette: React.FC<CreateIconComponentProps> = ({
  title = 'Palette',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent viewBox="0 0 16 16" title={title} {...props}>
    <path d="M5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM11.5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9.5 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.29.5A7.5 7.5 0 0 0 .5 8a2.91 2.91 0 0 0 3.677 2.807h.001l.56-.155A1 1 0 0 1 6 11.62v1.88a2 2 0 0 0 2 2 7.5 7.5 0 0 0 7.5-7.79A7.525 7.525 0 0 0 8.29.5l-.02.5.02-.5Zm4.858 9.457a5.446 5.446 0 0 1-1.015 1.675l-.17.178A5.466 5.466 0 0 1 8 13.5v-1.88a3 3 0 0 0-3.797-2.892h-.001l-.558.155A.91.91 0 0 1 2.5 8V8a5.5 5.5 0 0 1 5.712-5.5 5.59 5.59 0 0 1 5.289 5.289 5.446 5.446 0 0 1-.353 2.168Z"
    />
  </CreateIconComponent>
);

export default Palette;
